import { useProjectConfirmationLightDuty } from "app/frontend/components/eligibility/accordions/confirmation/useProjectConfirmationLightDuty";
import { useProjectConfirmationMHD } from "app/frontend/components/eligibility/accordions/confirmation/useProjectConfirmationMHD";
import { useProjectConfirmationMicromobility } from "app/frontend/components/eligibility/accordions/confirmation/useProjectConfirmationMicromobility";
import { EProjectTypes } from "app/frontend/constants/enums";
import { useParamsProjectType } from "app/frontend/hooks/project/useParamsProjectType";

export const useProjectConfirmationComponents = () => {
    const projectType = useParamsProjectType();

    const mhd = useProjectConfirmationMHD();
    const lightDuty = useProjectConfirmationLightDuty();
    const micromobility = useProjectConfirmationMicromobility();

    return {
        [EProjectTypes.MHD]: mhd,
        [EProjectTypes.L2]: lightDuty,
        [EProjectTypes.MICROMOBILITY]: micromobility,
        [EProjectTypes.DCFC]: lightDuty,
        [EProjectTypes.MIXED]: lightDuty,
        [EProjectTypes.ALL]: lightDuty,
    }[projectType]();
};
